<template>
	<svg viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1 3H8.5C9.88071 3 11 4.11929 11 5.5V5.5V5.5C11 6.88071 9.88071 8 8.5 8H5M1 3L3 1M1 3L3 5" stroke="currentColor" stroke-linecap="round"/>
	</svg>
</template>

<script>
export default {
  name : 'icon-undo',
};
</script>
